export default __webpack_public_path__ + "static/media/gallery4.531007c7.jpg";